// Overflow menu for the viewer toolbar. Replaces the old ExportMenu, which
// mixed two ideas: it was labelled "Export" but also hid "Present full screen",
// a display MODE nobody thinks to look for under an export verb. Presenting is
// now its own toolbar button; everything genuinely occasional lives here.
//
// The parent owns every side-effect; this only assembles the item list.

import { Menu, type MenuItem } from "./Menu";
import { Icon } from "./Icon";

interface Props {
  /** Multi-file bundles download as .zip; single-file docs as plain HTML. */
  multiFile: boolean;
  /** Hidden on phones, where the whole toolbar collapses into one menu. */
  iconOnly?: boolean;
  /** True once THIS account has personally trusted the doc (offers revoke). */
  personallyTrusted: boolean;
  onDownloadHtml: () => void;
  onDownloadZip: () => void;
  onExportPdf: () => void;
  onExportImage: () => void;
  onDuplicate: () => void;
  onViewStats: () => void;
  onRevokeMyTrust: () => void;
}

export function MoreMenu({
  multiFile,
  iconOnly = false,
  personallyTrusted,
  onDownloadHtml,
  onDownloadZip,
  onExportPdf,
  onExportImage,
  onDuplicate,
  onViewStats,
  onRevokeMyTrust,
}: Props) {
  const items: MenuItem[] = [
    { label: "Export PDF…", icon: "pdf", onSelect: onExportPdf },
    { label: "Export image…", icon: "image", onSelect: onExportImage },
    multiFile
      ? { label: "Download bundle (.zip)", icon: "download", onSelect: onDownloadZip }
      : { label: "Download HTML", icon: "download", onSelect: onDownloadHtml },
    { label: "Duplicate", icon: "copy", onSelect: onDuplicate },
    { label: "View stats…", icon: "chart", onSelect: onViewStats },
    ...(personallyTrusted
      ? [
          {
            label: "Remove my trust",
            icon: "shield" as const,
            onSelect: onRevokeMyTrust,
          },
        ]
      : []),
  ];

  return (
    <Menu
      ariaLabel="More actions"
      align="right"
      caret={!iconOnly}
      trigger={
        <>
          <Icon name="more" size={18} />
          {!iconOnly && <span>More</span>}
        </>
      }
      items={items}
    />
  );
}
